import Loader from 'common/modules/loader'
import { PROMPT_TAG, MENU_TAG, HEADER_TAG } from 'common/tags'
import { FRAME_STATES } from '../reducer'

const selectors = {
    // eslint-disable-next-line max-len
    haveAllFrameInitialized: ({ arbiter } = {}) => arbiter?.allFramesReady,
    hasPicoInitialed: ({ arbiter } = {}) => arbiter?.init,
    executePostLoaderActions: ({ arbiter } = {}) => arbiter?.executePostLoaderActions,
    isPicoDisplayed: ({ arbiter } = {}) => {
        const framesToClose = [PROMPT_TAG, MENU_TAG, HEADER_TAG]
        const framesAreShown = (frame) => arbiter?.frames[frame]?.status === FRAME_STATES.DISPLAYED
        return framesToClose.some(framesAreShown)
    },
    decoratorPayload: (state, adBlocked) => {
        const popups = Loader.selectors.popups(state)
        const planOptions = Loader.selectors.popupPlanOptions(state)

        const userFirstName = Loader.selectors.userFirstName(state)
        const userEmail = Loader.selectors.userEmail(state)
        const userVerified = Loader.selectors.userVerified(state)
        const userStatus = Loader.selectors.userStatus(state)

        const defaultPopup = Loader.selectors.getDefaultPopup(state)
        const userProduct = Loader.selectors.currentProductTitle(state)

        const signalsPayload = {
            adBlocked,
            userTier: userProduct,
            userEmail,
            userFirstName,
            userStatus,
            userVerified,
            userProduct,
        }

        return {
            planOptions,
            signalsPayload,
            popups: [...popups, defaultPopup],
        }
    },
    allFramesCreated: ({ arbiter } = {}) => {
        const frames = arbiter?.frames

        const isHeaderCreated = frames?.pico_header?.status === 'CREATED'
        const isMenuCreated = frames?.pico_menu?.status === 'CREATED'
        const isPromptCreated = frames?.pico_prompt?.status === 'CREATED'
        const allFramesCreated = (
            isHeaderCreated
            && isMenuCreated
            && isPromptCreated
        )

        return allFramesCreated
    },
    allFramesHidden: ({ arbiter } = {}) => {
        const frames = arbiter?.frames

        const isHeaderHidden = frames?.pico_header?.status === 'HIDDEN'
        const isMenuHidden = frames?.pico_menu?.status === 'HIDDEN'
        const isPromptHidden = frames?.pico_prompt?.status === 'HIDDEN'
        const allFramesHidden = (
            isHeaderHidden
            && isMenuHidden
            && isPromptHidden
        )

        return allFramesHidden
    },
    canShowPopup: (state) => {
        const allFramesHidden = selectors.allFramesHidden(state)
        const allFramesCreated = selectors.allFramesCreated(state)

        return (
            allFramesHidden
            || allFramesCreated
        )
    },
    promptDisplayed: ({ arbiter } = {}) => {
        const frames = arbiter?.frames
        const isPromptDisplayed = frames?.pico_prompt?.status === 'DISPLAYED'

        return isPromptDisplayed
    },
}

export default selectors
